import React from "react";
import {
  Row,
  Col,
  Drawer,
  Form,
  Input,
  Button,
  Checkbox,
  Modal,
  message,
  Select,
  Divider,
} from "antd";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import Helmet from "react-helmet";
import { API } from "aws-amplify";
import { sessionActions } from "redux/modules/session";
import * as Styled from "./styled";
import { SHIPPING } from "config.js";

const FormItem = Form.Item;
const Option = Select.Option;

const SHIP_OPTIONS = [
  "1 Day",
  "Express",
  "Standard Shipping",
  "Free shipping (USPS First Class Mail)",
];

class StoreConfig extends React.Component {
  state = {
    saving: false,
  };

  componentDidMount() {
    const { stores, currentStoreId } = this.props;
    const store = stores.find((s) => s.storeId === currentStoreId);
    if (store) {
      this.props.form.setFieldsValue(store);
    }
  }

  onClose = () => {
    this.props.dispatch(push("/settings/stores"));
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          saving: true,
        });
        API.put("api", `stores/${this.props.match.params.storeId}`, {
          body: values,
        }).then(
          (resp) => {
            this.props.dispatch(sessionActions.setStore(resp));
            message.success("Store updated");
            this.onClose();
          },
          (e) => {
            message.error(e.response.data.message);
          }
        );
      }
    });
  };

  onDisconnect = () => {
    Modal.confirm({
      title: "Are you sure you want to disconnect this store?",
      content: (
        <div>
          <p>
            You will no longer be able to fulfill orders from your store. All
            your mappings and images will remain, you can reconnect your store
            again later.
          </p>
        </div>
      ),
      onOk: () => {
        this.props.dispatch(
          sessionActions.disconnectStore(this.props.currentStoreId)
        );
      },
    });
  };

  renderForm = () => {
    const { stores, currentStoreId, labData, form } = this.props;
    const { getFieldDecorator } = form;
    const store = stores.find((s) => s.storeId === currentStoreId);

    return (
      <Form onSubmit={this.onSubmit}>
        <p>
          Set default shipping method.
        </p>
        <FormItem>
          {getFieldDecorator(`defaultShippingOption`, {
            initialValue:
              store.defaultShippingOption,
          })(
            <Select placeholder="Please select default shipping method">
              {labData.shipping.filter(i => i.shiptype ==='dropship').map((s) => (
                <Option key={s.pos_code} value={s.pos_code}>
                  {s.shippingmethod} ${s.price}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
        <h4>We no longer support shipping outside the US</h4>
        <p>
          Due to issues with VAT taxes we no longer support international
          shipping (orders outside the US).
        </p>

        <Divider />
        <FormItem>
          {getFieldDecorator("hideUnmappedOrders", {
            valuePropName: "checked",
            initialValue: false,
          })(
            <Checkbox>
              Hide orders without a mapping from the Orders page.
            </Checkbox>
          )}
        </FormItem>
        <br />
        <Row type="flex" justify="space-between">
          <Col>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              loading={this.state.saving}
            >
              Submit
            </Button>
          </Col>
          <Col>
            <Button type="danger" size="large" onClick={this.onDisconnect}>
              Disconnect
            </Button>
          </Col>
        </Row>
      </Form>
    );
  };

  render() {
    return (
      <Drawer
        visible
        title="Store settings"
        width={600}
        onClose={this.onClose}
        style={{
          overflow: "auto",
          height: "calc(100% - 108px)",
          paddingBottom: "108px",
        }}
      >
        <Styled.Container>
          <Helmet title="Store settings" />
          {this.renderForm()}
        </Styled.Container>
      </Drawer>
    );
  }
}

export default connect((state, props) => ({
  ...state.session,
  ...state.lab,
  currentStoreId: props.match.params.storeId,
}))(Form.create()(StoreConfig));
